import React, { createContext, useContext } from "react";
import IAppStore from "../../store/contracts/IAppStore";
import useAppStoreHook from "./useAppStore.hook";


// <1:1> create the context, this will now expose the functionalities of the hook to the caller
export const AppStoreContext = createContext({} as IAppStore);

interface IProps {
  children: React.ReactNode
}
// <1:3> create the provider for the context
export const AppStoreContextProvider = ({ children }: IProps) => {

  // NOTE: this is not directly exposed to the child components
  // we are exposing this object only through the context eg: const hookProps = useContext(<context_name>);
  const appStoreHook: IAppStore = useAppStoreHook();


  return (
    <AppStoreContext.Provider value={appStoreHook}>
      {children}
    </AppStoreContext.Provider>
  );
}

// use useMuiThemeContext in client components to extract the theme hooks
const useAppStoreContext = () => useContext(AppStoreContext)
export default useAppStoreContext;